module.exports = __webpack_public_path__ + "static/pinkwelcome-7edf9a14a814d770c4b86682b71a86e6.jpeg";